export default "__VITE_ASSET__c37ddd30__"